import { FC, PropsWithChildren, ReactElement } from 'react';

import { Page } from '../../../components';
import { NotFound } from '../../../containers';
import { useClientEffect } from '../../../hooks';
import { fetchBrands } from '../../../redux/@brands/brands/brandsActions';
import { useTypedDispatch, useTypedSelector } from '../../../redux/store';

type ConnectedBrandOverviewWrapperProps = PropsWithChildren;

export const ConnectedBrandOverviewWrapper: FC<ConnectedBrandOverviewWrapperProps> = ({
    children,
}): ReactElement => {
    const dispatch = useTypedDispatch();

    const hasFetched = useTypedSelector(state => state.brandsSlice.hasFetched);
    const navigation = useTypedSelector(state => state.brandsSlice.navigation);

    useClientEffect((): void => {
        dispatch(fetchBrands());
    }, []);

    if (hasFetched && !navigation) {
        return (
            <Page>
                <NotFound />
            </Page>
        );
    }

    return (
        <div>
            {children}
        </div>
    );
};
